import { httpGet } from "@/api/connection";
import { CUSTOM_FIELD_CATEGORIES, CustomField } from "./custom-fields.types";

export type GetCustomFieldsQuery = {
  category?: CUSTOM_FIELD_CATEGORIES;
};

export type GetCustomFieldsResponse = { data: CustomField[] };

export type GetCustomFieldsFn = (
  query?: GetCustomFieldsQuery
) => Promise<GetCustomFieldsResponse>;

const getCustomFields: GetCustomFieldsFn = async (query) => {
  const res = await httpGet("/custom-fields", query);
  // httpGet never rejects — HTTP/network failures resolve as
  // { success: false, error } (connection.js handleError). Throw so
  // react-query consumers get a real error state instead of isSuccess with
  // an unusable payload (which would open enabled-gates that depend on the
  // custom-field definitions having actually loaded).
  if (!res || res.success === false || !Array.isArray(res.data)) {
    throw new Error("Failed to load custom fields");
  }
  return res;
};

export const CustomFieldsAPI = {
  get: getCustomFields,
};
